import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MatSnackBar } from '@angular/material';
import { BenutzerService } from '../../service/benutzer.service';
import { Router } from '@angular/router';
import { UserinfoService } from '../../service/userinfo.service';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { formatDate } from '@angular/common';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
var AppMeinkonto = /** @class */ (function () {
    function AppMeinkonto(benutzerService, router, userinfoservice, snackBar, dialog) {
        this.benutzerService = benutzerService;
        this.router = router;
        this.userinfoservice = userinfoservice;
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.meinkontoModel = {};
        this.regexTelefon = "/^\\+?([0-9]{2})\\)?[ ]?([0-9]{2})[ ]?([0-9]{4})[ ]?([0-9]{4})$/";
        this.regexHandyTelefon = "/^\\+?([0-9]{2})\\)?[ ]?([0-9]{3})[ ]?([0-9]{4})$/";
        this.dig = "/^\d+$/";
        this.vermittlerHinzufuegen = "";
        this.plzZuVermittlerNr = "";
        this.vermittlerNrList = [];
        this.vtnrs = {};
        this.vtnrsAdded = [];
        this.rollen = {};
        this.rollenBeforDelete = []; //zu Ermitlung von gelöschten Rollen
        this.rollenNew = [];
        //Views
        this.isPersonlicheDaten = true;
        this.isMeineBerechtigungen = false;
        this.isBerechtigungen = false;
        this.isBestaetigung = false;
        this.isPruefung = false;
        this.isVtnrView = false;
        this.isOhneDownloadFunktion = false;
        this.isMitDownloadFunktion = false;
        this.isOhneDownloadFunktionKranken = false;
        this.isMitDownloadFunktionKranken = false;
        this.isOhneDownloadFunktionLeben = false;
        this.isMitDownloadFunktionLeben = false;
        this.isCourtage = false;
        this.isCourtageAbrechnungen = false;
        this.isAnzeigeEigeneVorgaenge = true;
        this.isZusaetzlicheAnzeige = false;
        this.isTarifierung = false;
        this.isDruck = true;
        this.isOhneDownloadFunktionOld = false;
        this.isMitDownloadFunktionOld = false;
        this.isOhneDownloadFunktionKrankenOld = false;
        this.isMitDownloadFunktionKrankenOld = false;
        this.isOhneDownloadFunktionLebenOld = false;
        this.isMitDownloadFunktionLebenOld = false;
        this.isCourtageOld = false;
        this.isCourtageAbrechnungenOld = false;
        this.isAnzeigeEigeneVorgaengeOld = true;
        this.isZusaetzlicheAnzeigeOld = false;
        this.isTarifierungOld = false;
        this.isDruckOld = true;
        this.isEinverstaendnis = false;
        this.anrede = ["Herr", "Frau"];
        this.dateMeinKonto = formatDate(new Date(), 'dd.MM.yyyy', 'de');
    }
    AppMeinkonto.prototype.ngOnInit = function () {
        var _this = this;
        this.benutzerService.getMeinKonto().subscribe(function (meinkonto) {
            _this.meinkontoModel = meinkonto;
            if (_this.meinkontoModel.anrede.indexOf('Ms') > -1) {
                _this.meinkontoModel.anrede = "Frau";
            }
            else {
                _this.meinkontoModel.anrede = "Herr";
            }
        }, function (error) {
            _this.snackBar.open("Aktuell ist aus technischen Gründen die Ermittlung Ihrer Daten zur Änderung leider nicht ermittelt werden. Bitte versuchen Sie es später erneut oder benutzen Sie das Freischaltformular", null, { duration: 3000, panelClass: ["bgc-red-400"] });
            // this.errorHandling(error);
        });
    };
    AppMeinkonto.prototype.openDialog = function (vtnr) {
        var _this = this;
        var vermittler = vtnr;
        var dialogRef = this.dialog.open(DialogOverview, {
            width: '600px',
            data: vermittler
        });
        dialogRef.afterClosed().subscribe(function (result) {
            console.log(result + 'The dialog was closed');
            if (result != null) {
                _this.deleteVtnr(vtnr);
            }
        });
    };
    AppMeinkonto.prototype.setCharAt = function (str, index, chr) {
        if (index > str.length - 1)
            return str;
        return str.substr(0, index) + chr + str.substr(index + 1);
    };
    AppMeinkonto.prototype.showValidationOfFaxTel = function (nummer, val) {
        if (val.indexOf('telefon') > -1 && this.meinkontoModel.telefon.length > 0) {
            this.meinkontoModel.telefon = nummer;
            if (this.meinkontoModel.telefon.startsWith('+0')) {
                this.meinkontoModel.telefon = '+49 ' + nummer.substr(2, nummer.length);
            }
            else if (this.meinkontoModel.telefon.startsWith('0')) {
                this.meinkontoModel.telefon = '+49 ' + nummer.substr(1, nummer.length);
            }
            else if (this.meinkontoModel.telefon.startsWith('49')) {
                this.meinkontoModel.telefon = '+ ' + nummer;
            }
            else if (this.meinkontoModel.telefon.startsWith('+')) {
                if (this.meinkontoModel.telefon.startsWith('+49')) {
                    this.meinkontoModel.telefon = nummer;
                }
                else if (this.meinkontoModel.telefon.startsWith('+ 49')) {
                    this.meinkontoModel.telefon = nummer;
                }
                else {
                    this.meinkontoModel.telefon = '+49 ' + nummer.substr(1, nummer.length);
                }
            }
        }
        else if (val.indexOf('mobil') > -1 && this.meinkontoModel.mobile.length > 0) {
            this.meinkontoModel.mobile = nummer;
            if (this.meinkontoModel.mobile.startsWith('+0')) {
                this.meinkontoModel.mobile = '+49 ' + nummer.substr(2, nummer.length);
            }
            else if (this.meinkontoModel.mobile.startsWith('0')) {
                this.meinkontoModel.mobile = '+49 ' + nummer.substr(1, nummer.length);
            }
            else if (this.meinkontoModel.mobile.startsWith('49')) {
                this.meinkontoModel.mobile = '+ ' + nummer;
            }
            else if (this.meinkontoModel.mobile.startsWith('+')) {
                if (this.meinkontoModel.mobile.startsWith('+49')) {
                    this.meinkontoModel.mobile = nummer;
                }
                else if (this.meinkontoModel.mobile.startsWith('+ 49')) {
                    this.meinkontoModel.mobile = nummer;
                }
                else {
                    this.meinkontoModel.mobile = '+49 ' + nummer.substr(1, nummer.length);
                }
            }
        }
        else if (val.indexOf('fax') > -1 && this.meinkontoModel.fax.length > 0) {
            this.meinkontoModel.fax = nummer;
            if (this.meinkontoModel.fax.startsWith('+0')) {
                this.meinkontoModel.fax = '+49 ' + nummer.substr(2, nummer.length);
            }
            else if (this.meinkontoModel.fax.startsWith('0')) {
                this.meinkontoModel.fax = '+49 ' + nummer.substr(1, nummer.length);
            }
            else if (this.meinkontoModel.fax.startsWith('49')) {
                this.meinkontoModel.fax = '+ ' + nummer;
            }
            else if (this.meinkontoModel.fax.startsWith('+')) {
                if (this.meinkontoModel.fax.startsWith('+49')) {
                    this.meinkontoModel.fax = nummer;
                }
                else if (this.meinkontoModel.fax.startsWith('+ 49')) {
                    this.meinkontoModel.fax = nummer;
                }
                else {
                    this.meinkontoModel.fax = '+49 ' + nummer.substr(1, nummer.length);
                }
            }
        }
    };
    AppMeinkonto.prototype.errorTelFaxMobil = function () {
        this.snackBar.open("Das erste Zeichen muss ein + sein.", null, { duration: 3000, panelClass: ["bgc-red-400"] });
    };
    AppMeinkonto.prototype.cleanTelAndFax = function (nummer, val) {
        var plusZeichen = "+";
        var ziffersOnly = nummer.substr(0, nummer.length).replace(/[ ]{2,}/g, ' ');
        ziffersOnly = ziffersOnly.substr(0, ziffersOnly.length).replace(/(?![\s])[^0-9]+/g, ' ');
        var zwischenErgebniss = plusZeichen + ziffersOnly;
        if (zwischenErgebniss.startsWith("+490")) {
            zwischenErgebniss = this.setCharAt(zwischenErgebniss, 3, ' ');
            zwischenErgebniss = zwischenErgebniss.substr(0, zwischenErgebniss.length).replace(/[ ]{2,}/g, ' ');
        }
        else if (zwischenErgebniss.startsWith("+49 0")) {
            zwischenErgebniss = this.setCharAt(zwischenErgebniss, 4, ' ');
            zwischenErgebniss = zwischenErgebniss.substr(0, zwischenErgebniss.length).replace(/[ ]{2,}/g, ' ');
        }
        this.showValidationOfFaxTel(zwischenErgebniss, val);
    };
    AppMeinkonto.prototype.generatePdf = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var adress, email, fax, newVList, documentDefinition;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        adress = "";
                        email = "";
                        fax = "";
                        return [4 /*yield*/, this.benutzerService.postGenehmiger(this.rollenNew, this.vermittlerNrList, this.rollenBeforDelete).then(function (code) {
                                if (code._body.indexOf("Nord") > -1) {
                                    adress = "Allianz Versicherungs-AG\nDG Nordost - BS Berlin\nAbteilung Maklervertrieb-Stab\nMerlitzstraße 8\n12489 Berlin";
                                    email = "maklerportal-berlin@allianz.de";
                                    fax = "+49 (30) 53893 822909";
                                }
                                if (code._body.indexOf("Süd-Stuttgart") > -1) {
                                    adress = "Allianz Versicherungs-AG\nDG Südwest - BS Stuttgart\nAbteilung Maklervertrieb-Stab\nUhlandstraße 2\n70182 Stuttgart";
                                    email = "maklerportal-stuttgart@allianz.de";
                                    fax = "+49 (711) 2173 4022";
                                }
                                if (code._body.indexOf("Süd-Frankfurt") > -1) {
                                    adress = "Allianz Versicherungs-AG\nDG Südwest - / BS Frankfurt\nAbteilung Maklervertrieb-Stab\nTheodor-Stern-Kai 1\n60596 Frankfurt";
                                    email = "maklerportal-frankfurt@allianz.de";
                                    fax = "+49 (69) 7126 4022";
                                }
                                if (code._body.indexOf("Süd-München") > -1) {
                                    adress = "Allianz Versicherungs-AG\nDG Südost - BS München\nAbteilung Maklervertrieb-Stab\nDieselstraße 8\n85774 Unterföhring";
                                    email = "maklerportal-muenchen@allianz.de";
                                    fax = "+49 (89) 9900 14011";
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.vermittlerNrListToStringForPdf()];
                    case 2:
                        newVList = _a.sent();
                        documentDefinition = { content: [
                                { text: 'Allianz Online Service',
                                    fontSize: 14,
                                    alignment: 'center' },
                                {
                                    text: adress,
                                    fontSize: 8,
                                    alignment: 'left'
                                },
                                {
                                    text: this.dateMeinKonto,
                                    fontSize: 8,
                                    alignment: 'right'
                                },
                                {
                                    text: '\nFax:' + fax + '\nEmail:' + email,
                                    fontSize: 8,
                                    alignment: 'left'
                                },
                                {
                                    text: '\nÄnderungsauftrag für Benutzerschlüssel ' + this.meinkontoModel.bensl + "( " + this.meinkontoModel.vorname + ', ' + this.meinkontoModel.name + " )",
                                    fontSize: 14,
                                    alignment: 'left'
                                },
                                {
                                    text: '\nÜbersicht Vermittlernummern:',
                                    fontSize: 10,
                                    alignment: 'left'
                                },
                                {
                                    text: 'folgende Vermittlernummern sollen für meinen Zugang hintergelegt sein:',
                                    fontSize: 8,
                                    alignment: 'left',
                                    bold: true
                                },
                                {
                                    text: newVList,
                                    fontSize: 8,
                                    alignment: 'left'
                                },
                                {
                                    text: '\nFür meinen Zugang sollen folgende Berechtigungen eingerichtet werden:',
                                    fontSize: 8,
                                    alignment: 'left',
                                    bold: true
                                },
                                {
                                    text: '\nVerwaltung',
                                    fontSize: 14,
                                    alignment: 'left',
                                    bold: true
                                },
                                {
                                    text: '\na. Bestand & Schaden',
                                    fontSize: 10,
                                    alignment: 'left',
                                    bold: true
                                },
                                {
                                    layout: 'noBorders',
                                    table: {
                                        // headers are automatically repeated if the table spans over multiple pages
                                        // you can declare how many rows should be treated as headers
                                        headerRows: 1,
                                        widths: ['*', 50, 50, '*'],
                                        body: [
                                            ['', 'Bisher', 'Neu', ''],
                                            ['Kunden, Verträge, Schäden, Postfach:', this.isOhneDownloadFunktionOld ? '[X]' : '[_]', this.isOhneDownloadFunktion ? '[X]' : '[_]', 'Ohne Downloadfunktion'],
                                            ['', this.isMitDownloadFunktionOld ? '[X]' : '[_]', this.isMitDownloadFunktion ? '[X]' : '[_]', 'Mit Downloadfunktion']
                                        ]
                                    }
                                },
                                {
                                    text: '\nb. Courtage & Abrechnung\n',
                                    fontSize: 10,
                                    alignment: 'left',
                                    bold: true
                                },
                                {
                                    layout: 'noBorders',
                                    table: {
                                        // headers are automatically repeated if the table spans over multiple pages
                                        // you can declare how many rows should be treated as headers
                                        headerRows: 0,
                                        widths: ['*', 50, 50, '*'],
                                        body: [
                                            ['Courtagesätze Sach/Leben:', this.isCourtageOld ? '[X]' : '[_]', this.isCourtage ? '[X]' : '[_]', ''],
                                        ]
                                    }
                                },
                                {
                                    text: '\n',
                                    fontSize: 14,
                                    alignment: 'left',
                                    bold: true
                                },
                                {
                                    layout: 'noBorders',
                                    table: {
                                        // headers are automatically repeated if the table spans over multiple pages
                                        // you can declare how many rows should be treated as headers
                                        headerRows: 0,
                                        widths: ['*', 50, 50, '*'],
                                        body: [
                                            ['Abrechnung Sach Vermittlerinkasso (Courtage, Beisträge, Schäden):', this.isCourtageAbrechnungenOld ? '[X]' : '[_]', this.isCourtageAbrechnungen ? '[X]' : '[_]', ''],
                                        ]
                                    }
                                },
                                {
                                    text: '\n',
                                    fontSize: 14,
                                    alignment: 'left',
                                    bold: true
                                },
                                {
                                    layout: 'noBorders',
                                    table: {
                                        // headers are automatically repeated if the table spans over multiple pages
                                        // you can declare how many rows should be treated as headers
                                        headerRows: 0,
                                        widths: ['*', 50, 50, '*'],
                                        body: [
                                            ['Buchungen Leben(Vergütungsabrechnungen & Einzelbuchungen):', this.isMitDownloadFunktionLebenOld ? '[X]' : '[_]', this.isMitDownloadFunktionLeben ? '[X]' : '[_]', 'Mit Downloadfunktion'],
                                            ['', this.isOhneDownloadFunktionKrankenOld ? '[X]' : '[_]', this.isOhneDownloadFunktionKranken ? '[X]' : '[_]', 'Ohne Downloadfunktion'],
                                        ]
                                    }
                                },
                                {
                                    text: '\n\n',
                                    fontSize: 14,
                                    alignment: 'left',
                                    bold: true
                                },
                                {
                                    layout: 'noBorders',
                                    table: {
                                        // headers are automatically repeated if the table spans over multiple pages
                                        // you can declare how many rows should be treated as headers
                                        headerRows: 0,
                                        widths: ['*', 50, 50, '*'],
                                        body: [
                                            ['Courtagedaten Kranken:', this.isMitDownloadFunktionKrankenOld ? '[X]' : '[_]', this.isMitDownloadFunktionKranken ? '[X]' : '[_]', 'Mit Downloadfunktion'],
                                            ['', this.isOhneDownloadFunktionKrankenOld ? '[X]' : '[_]', this.isOhneDownloadFunktionKranken ? '[X]' : '[_]', 'Ohne Downloadfunktion'],
                                        ]
                                    }
                                },
                                {
                                    text: '\n',
                                    fontSize: 14,
                                    alignment: 'left',
                                    bold: true
                                },
                                {
                                    text: '\nRechner & Tools',
                                    fontSize: 14,
                                    alignment: 'left',
                                    bold: true
                                },
                                {
                                    layout: 'noBorders',
                                    table: {
                                        headerRows: 0,
                                        widths: ['*', 50, 50, '*'],
                                        body: [
                                            ['Online-Tarifrechner Kraft, Leben, Kranken', this.isAnzeigeEigeneVorgaengeOld ? '[X]' : '[_]', this.isAnzeigeEigeneVorgaenge ? '[X]' : '[_]', 'Anzeige eigener Vorgänger zu den angegebenen Vermittlernummern*'],
                                            ['', this.isZusaetzlicheAnzeigeOld ? '[X]' : '[_]', this.isZusaetzlicheAnzeige ? '[X]' : '[_]', 'Zusätzliche Anzeige aller Vorgänge zu den angegebenen Vermittlernummern(sog. Super-Legi)'],
                                        ]
                                    }
                                },
                                {
                                    text: '\n',
                                    fontSize: 14,
                                    alignment: 'left',
                                    bold: true
                                },
                                {
                                    layout: 'noBorders',
                                    table: {
                                        // headers are automatically repeated if the table spans over multiple pages
                                        // you can declare how many rows should be treated as headers
                                        headerRows: 0,
                                        widths: ['*', 50, 50, '*'],
                                        body: [
                                            ['Tarifierung Sach/KV-Profi und eBV', this.isTarifierungOld ? '[X]' : '[_]', this.isTarifierung ? '[X]' : '[_]', ''],
                                        ]
                                    }
                                },
                                {
                                    text: '\n',
                                    fontSize: 14,
                                    alignment: 'left',
                                    bold: true
                                },
                                {
                                    text: '\nService',
                                    fontSize: 14,
                                    alignment: 'left',
                                    bold: true
                                },
                                {
                                    layout: 'noBorders',
                                    table: {
                                        // headers are automatically repeated if the table spans over multiple pages
                                        // you can declare how many rows should be treated as headers
                                        headerRows: 0,
                                        widths: ['*', 50, 50, '*'],
                                        body: [
                                            ['Geschützter Content/Bestell-Center', this.isDruckOld ? '[X]' : '[_]', this.isDruck ? '[X]' : '[_]', ''],
                                        ]
                                    }
                                },
                                {
                                    text: '\n\n*Hinweis: Diese Anwendung ist standardmäßig hinterlegt und kann nicht abgewählt werden.',
                                    fontSize: 6,
                                    alignment: 'left',
                                },
                                {
                                    text: '\n\n[X] Berechtigung soll für den Zugang gelten',
                                    fontSize: 8,
                                    alignment: 'left',
                                },
                                {
                                    text: '\n\n[_] Berechtigung soll nicht für den Zugang gelten',
                                    fontSize: 8,
                                    alignment: 'left',
                                },
                                {
                                    text: '\n\nMit unserer Unterschrift erklären wir als vertretungsberechtigte und/oder nutzungsberechtigte Personen unser Einverständnis mit den Nutzungsbedingungen (AGB) für die Onlinedienste der Allianz in der jeweils gültigen Fassung.',
                                    fontSize: 8,
                                    alignment: 'left',
                                },
                                {
                                    text: '\n\nUnterschrift\n',
                                    fontSize: 12,
                                    alignment: 'left',
                                },
                                {
                                    layout: 'noBorders',
                                    table: {
                                        // headers are automatically repeated if the table spans over multiple pages
                                        // you can declare how many rows should be treated as headers
                                        headerRows: 1,
                                        widths: [300, 300],
                                        body: [
                                            ['Ort, Datum', 'Vertragspartner/Geschäftsführer'],
                                            ['_________________________________', '________________________________'],
                                        ]
                                    }
                                }
                            ] };
                        pdfMake.createPdf(documentDefinition).open();
                        return [2 /*return*/];
                }
            });
        });
    };
    AppMeinkonto.prototype.vermittlerNrListToString = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var vtnrsAddedPDF, i;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        vtnrsAddedPDF = [];
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < this.vermittlerNrList.length)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.benutzerService.getVtnrAdress(this.vermittlerNrList[i]).then(function (res) {
                                vtnrsAddedPDF.push(res);
                            })];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, vtnrsAddedPDF];
                }
            });
        });
    };
    AppMeinkonto.prototype.vermittlerNrListToStringForPdf = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var vtnrsAddedPDF, vlist, j;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.vermittlerNrListToString().then()];
                    case 1:
                        vtnrsAddedPDF = _a.sent();
                        vlist = "";
                        for (j = 0; j < vtnrsAddedPDF.length; j++) {
                            vlist += "- " + vtnrsAddedPDF[j].vtnr + " , " + vtnrsAddedPDF[j].name.replace(/\n/g, ' ') + "\n";
                        }
                        return [2 /*return*/, vlist];
                }
            });
        });
    };
    AppMeinkonto.prototype.showPersonlicheDaten = function () {
        this.isPersonlicheDaten = true;
        this.isMeineBerechtigungen = false;
    };
    AppMeinkonto.prototype.showMeineBerechtigungen = function () {
        this.isPersonlicheDaten = false;
        this.isMeineBerechtigungen = true;
        this.showVtnrView();
    };
    AppMeinkonto.prototype.showVtnrView = function () {
        var _this = this;
        this.isVtnrView = true;
        this.isBerechtigungen = false;
        this.isPruefung = false;
        this.isBestaetigung = false;
        this.benutzerService.getAllVtnrs().subscribe(function (result) {
            _this.vtnrs = result;
            for (var i = 0; i < _this.vtnrs.length; i++) {
                _this.vermittlerNrList.push(_this.vtnrs[i].vtnr);
            }
        }, function (error) {
            _this.snackBar.open("Fehler beim Vtnr's lesen", null, { duration: 3000, panelClass: ["bgc-red-400"] });
            // this.errorHandling(error);
        });
    };
    AppMeinkonto.prototype.downloadFunktion = function () {
        this.isOhneDownloadFunktion = false;
    };
    AppMeinkonto.prototype.downloadFunktionOhne = function () {
        this.isMitDownloadFunktion = false;
    };
    AppMeinkonto.prototype.downloadFunktionKr = function () {
        this.isOhneDownloadFunktionKranken = false;
    };
    AppMeinkonto.prototype.downloadFunktionKrOhne = function () {
        this.isMitDownloadFunktionKranken = false;
    };
    AppMeinkonto.prototype.downloadFunktionLeben = function () {
        this.isOhneDownloadFunktionLeben = false;
    };
    AppMeinkonto.prototype.downloadFunktionLebenOhne = function () {
        this.isMitDownloadFunktionLeben = false;
    };
    AppMeinkonto.prototype.showBerechtigungen = function () {
        var _this = this;
        this.benutzerService.getSystemRoles().subscribe(function (result) {
            _this.rollen = result;
            if (result.length > 0) {
                _this.mapRoles(result);
            }
        }, function (error) {
            _this.snackBar.open("Fehler beim Vtnr's lesen", null, { duration: 3000, panelClass: ["bgc-red-400"] });
            // this.errorHandling(error);
        });
        this.isBerechtigungen = true;
        this.isVtnrView = false;
        this.isBestaetigung = false;
        this.isPruefung = false;
    };
    AppMeinkonto.prototype.mapRoles = function (result) {
        for (var i = 0; i < result.length; i++) {
            this.checkRoles(result[i]);
        }
    };
    AppMeinkonto.prototype.checkRoles = function (result) {
        if (result.indexOf("P01-MP-GRUND") > -1) {
            this.isDruck = true;
            this.isDruckOld = true;
        }
        if (result.indexOf("F26-MP-TA-SK") > -1) {
            this.isTarifierung = true;
            this.isTarifierungOld = true;
        }
        if (result.indexOf("F03-MP-BMD-S") > -1) {
            this.isMitDownloadFunktion = true;
            this.isMitDownloadFunktionOld = true;
        }
        if (result.indexOf("F05-MP-BMP-S") > -1) {
            this.isOhneDownloadFunktion = true;
            this.isOhneDownloadFunktionOld = true;
        }
        if (result.indexOf("F10-MP-CR-SL") > -1) {
            this.isCourtage = true;
            this.isCourtageOld = true;
        }
        if (result.indexOf("F12-MP-CS-AS") > -1) {
            this.isCourtageAbrechnungen = true;
            this.isCourtageAbrechnungenOld = true;
        }
        if (result.indexOf("F07-MP-BDLMD") > -1) {
            this.isMitDownloadFunktionLeben = true;
            this.isMitDownloadFunktionLebenOld = true;
        }
        if (result.indexOf("F08-MP-BDLOD") > -1) {
            this.isOhneDownloadFunktionLeben = true;
            this.isOhneDownloadFunktionLebenOld = true;
        }
        if (result.indexOf("F21-MP-SB-KD") > -1) {
            this.isMitDownloadFunktionKranken = true;
            this.isMitDownloadFunktionKrankenOld = true;
        }
        if (result.indexOf("F22-MP-SB-OD") > -1) {
            this.isOhneDownloadFunktionKranken = true;
            this.isOhneDownloadFunktionKrankenOld = true;
        }
        if (result.indexOf("F25-MP-SLTLK") > -1) {
            this.isZusaetzlicheAnzeige = true;
            this.isZusaetzlicheAnzeigeOld = true;
        }
    };
    AppMeinkonto.prototype.showPruefung = function () {
        this.isBerechtigungen = true;
        this.isPruefung = true;
        this.isVtnrView = false;
        this.isBestaetigung = false;
    };
    AppMeinkonto.prototype.showBestaetigung = function () {
        this.isBestaetigung = true;
        this.isBerechtigungen = false;
        this.isPruefung = false;
        this.isVtnrView = false;
        this.generatePdf();
    };
    AppMeinkonto.prototype.rollenMappen = function () {
    };
    AppMeinkonto.prototype.postMeinKonto = function () {
        var _this = this;
        if (this.meinkontoModel.mobile.length > 0) {
            this.cleanTelAndFax(this.meinkontoModel.mobile, 'mobil');
        }
        if (this.meinkontoModel.fax.length > 0) {
            this.cleanTelAndFax(this.meinkontoModel.fax, 'fax');
        }
        if (this.meinkontoModel.telefon.length > 0) {
            this.cleanTelAndFax(this.meinkontoModel.telefon, 'telefon');
        }
        this.benutzerService.postMeinKonto(this.meinkontoModel).subscribe(function (code) {
            if (code.Code.string.indexOf("0") > -1) {
                _this.snackBar.open("Ihre Eingaben wurden erfolgreich verarbeitet und werden in der Regel morgen vollständig wirksam sein.", null, { duration: 3000, panelClass: ["bgc-green-400"] });
            }
            else if (code.Code.string.indexOf("112") > -1) {
                _this.snackBar.open("Änderung Alias fehlgeschlagen. Alias bereits vorhanden. Bitte wählen Sie einen anderen Aliasnamen.", null, { duration: 3000, panelClass: ["bgc-red-400"] });
            }
            else if (code.Code.string.indexOf("KOELNER") > -1) {
                _this.snackBar.open("Ein Wechsel der nutzungsberechtigten Person ist aus datenschutzrechtlichen Gründen nicht möglich. Bitte schicken Sie uns eine E-Mail an maklerportal@allianz.de.", null, { duration: 3000, panelClass: ["bgc-red-400"] });
            }
            else if (code.Code.string.indexOf("WRONGEINGABE") > -1) {
                _this.snackBar.open("Validierung fehlgeschlagen.", null, { duration: 3000, panelClass: ["bgc-red-400"] });
            }
            else if (code.Code.string.indexOf("500") > -1) {
                _this.snackBar.open("Ihre Eingaben wurden erfolgreich verarbeitet und werden in der Regel morgen vollständig wirksam sein.", null, { duration: 3000, panelClass: ["bgc-green-400"] });
            }
            else {
                _this.snackBar.open("Aktuell kann aus technischen Gründen Ihre Eingabe nicht verarbeitet werden. Bitte versuchen Sie es später erneut oder melden Sie die Änderungen mit dem Freischaltformular", null, { duration: 3000, panelClass: ["bgc-red-400"] });
            }
        }, function (error) {
            _this.snackBar.open("Aktuell kann aus technischen Gründen Ihre Eingabe nicht verarbeitet werden. Bitte versuchen Sie es später erneut oder melden Sie die Änderungen mit dem Freischaltformular", null, { duration: 3000, panelClass: ["bgc-red-400"] });
            // this.errorHandling(error);
        });
    };
    AppMeinkonto.prototype.checkRequest = function () {
        var _this = this;
        this.benutzerService.checkRequestId().subscribe(function (code) {
            if (code.Code.string.indexOf("0") > -1 && code.State.string.indexOf("Pending") > -1) {
                _this.snackBar.open("Die Änderung ist im Progress", null, { duration: 3000, panelClass: ["bgc-green-400"] });
            }
            else if (code.Code.string.indexOf("0") > -1 && code.State.string.indexOf("Active") > -1) {
                _this.snackBar.open("Die Änderungen wurden übernommen", null, { duration: 3000, panelClass: ["bgc-green-400"] });
            }
            else {
                _this.snackBar.open("Fehler beim Mein Konto!", null, { duration: 3000, panelClass: ["bgc-red-400"] });
            }
        }, function (error) {
            _this.snackBar.open("Error: Fehler beim Mein Konto!", null, { duration: 3000, panelClass: ["bgc-red-400"] });
            // this.errorHandling(error);
        });
    };
    AppMeinkonto.prototype.deleteVtnr = function (vtnr) {
        for (var i = 0; i < this.vermittlerNrList.length; i++) {
            if (this.vermittlerNrList[i].indexOf(vtnr) > -1) {
                this.vermittlerNrList.splice(i, 1);
            }
            if (this.vtnrs[i].vtnr.indexOf(vtnr) > -1) {
                this.vtnrs.splice(i, 1);
            }
            if (this.vtnrsAdded[i].vtnr.indexOf(vtnr) > -1) {
                this.vtnrsAdded.splice(i, 1);
            }
        }
    };
    AppMeinkonto.prototype.sendenPruefung = function () {
        var _this = this;
        if (this.isEinverstaendnis) {
            this.addRollen();
            this.checkNewRoles(this.rollenNew);
            for (var i = 0; i < this.rollen.length; i++) {
                this.checkDeletedRoles(this.rollen[i]);
            }
            this.benutzerService.postSendeNewRoles(this.rollenNew, this.vermittlerNrList, this.rollenBeforDelete).subscribe(function (code) {
                if (code.Code.indexOf("0") > -1) {
                    _this.snackBar.open("Ihre Eingaben wurden erfolgreich verarbeitet und werden in der Regel morgen vollständig wirksam sein.", null, {
                        duration: 3000,
                        panelClass: ["bgc-green-400"]
                    });
                    _this.showBestaetigung();
                }
                if (code.Code.indexOf("WRONGEINGABE") > -1) {
                    _this.snackBar.open("Validierung fehlgeschlagen", null, {
                        duration: 3000,
                        panelClass: ["bgc-red-400"]
                    });
                }
            }, function (error) {
                _this.snackBar.open("Aktuell kann aus technischen Gründen Ihre Eingabe nicht verarbeitet werden. Bitte versuchen Sie es später erneut oder melden Sie die Änderungen mit dem Freischaltformular", null, {
                    duration: 3000,
                    panelClass: ["bgc-red-400"]
                });
                // this.errorHandling(error);
            });
        }
    };
    AppMeinkonto.prototype.addVtnr = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.benutzerService.checkVtnr(this.vermittlerHinzufuegen, this.plzZuVermittlerNr).subscribe(function (result) {
                    if (result[0] == null) {
                        _this.snackBar.open("Postleitzahl und Vermittlernummer stimmen nicht überein. Bitte überprüfen Sie Ihre Eingaben.", null, { duration: 3000, panelClass: ["bgc-red-400"] });
                    }
                    else if (result[0].indexOf("NO") > -1) {
                        _this.snackBar.open("Postleitzahl und Vermittlernummer stimmen nicht überein. Bitte überprüfen Sie Ihre Eingaben.", null, { duration: 3000, panelClass: ["bgc-red-400"] });
                    }
                    else if (result[0].indexOf("OK") > -1) {
                        _this.vermittlerNrList.push(_this.vermittlerHinzufuegen);
                        _this.snackBar.open("Vermittlernummer hinzugefügt.", null, { duration: 3000, panelClass: ["bgc-green-400"] });
                        _this.benutzerService.getVtnrAdress(_this.vermittlerHinzufuegen).then(function (res) {
                            _this.vtnrsAdded.push(res);
                        }, function (error) {
                            _this.snackBar.open("Bitte überprüfen Sie Ihre Eingaben.", null, { duration: 3000, panelClass: ["bgc-red-400"] });
                            // this.errorHandling(error);
                        });
                    }
                }, function (error) {
                    _this.snackBar.open("Postleitzahl und Vermittlernummer stimmen nicht überein. Bitte überprüfen Sie Ihre Eingaben.", null, { duration: 3000, panelClass: ["bgc-red-400"] });
                    // this.errorHandling(error);
                });
                return [2 /*return*/];
            });
        });
    };
    AppMeinkonto.prototype.addRollen = function () {
        if (this.isDruck) {
            this.rollenNew.push("P01-MP-GRUND");
        }
        if (this.isTarifierung) {
            this.rollenNew.push("F26-MP-TA-SK");
        }
        if (this.isMitDownloadFunktion) {
            this.rollenNew.push("F03-MP-BMD-S");
        }
        if (this.isOhneDownloadFunktion) {
            this.rollenNew.push("F05-MP-BMP-S");
        }
        if (this.isCourtage) {
            this.rollenNew.push("F10-MP-CR-SL");
        }
        if (this.isCourtageAbrechnungen) {
            this.rollenNew.push("F12-MP-CS-AS");
        }
        if (this.isMitDownloadFunktionLeben) {
            this.rollenNew.push("F07-MP-BDLMD");
        }
        if (this.isOhneDownloadFunktionLeben) {
            this.rollenNew.push("F08-MP-BDLOD");
        }
        if (this.isMitDownloadFunktionKranken) {
            this.rollenNew.push("F21-MP-SB-KD");
        }
        if (this.isOhneDownloadFunktionKranken) {
            this.rollenNew.push("F22-MP-SB-OD");
        }
        if (this.isZusaetzlicheAnzeige) {
            this.rollenNew.push("F25-MP-SLTLK");
        }
    };
    AppMeinkonto.prototype.checkDeletedRoles = function (result) {
        if (result.indexOf("P01-MP-GRUND") > -1 && !this.isDruck) {
            this.rollenBeforDelete.push("P01-MP-GRUND");
        }
        if (result.indexOf("F26-MP-TA-SK") > -1 && !this.isTarifierung) {
            this.rollenBeforDelete.push("F26-MP-TA-SK");
        }
        if (result.indexOf("F03-MP-BMD-S") > -1 && !this.isMitDownloadFunktion) {
            this.rollenBeforDelete.push("F03-MP-BMD-S");
        }
        if (result.indexOf("F05-MP-BMP-S") > -1 && !this.isOhneDownloadFunktion) {
            this.rollenBeforDelete.push("F05-MP-BMP-S");
        }
        if (result.indexOf("F10-MP-CR-SL") > -1 && !this.isCourtage) {
            this.rollenBeforDelete.push("F10-MP-CR-SL");
        }
        if (result.indexOf("F12-MP-CS-AS") > -1 && !this.isCourtageAbrechnungen) {
            this.rollenBeforDelete.push("F12-MP-CS-AS");
        }
        if (result.indexOf("F07-MP-BDLMD") > -1 && !this.isMitDownloadFunktionLeben) {
            this.rollenBeforDelete.push("F07-MP-BDLMD");
        }
        if (result.indexOf("F08-MP-BDLOD") > -1 && !this.isOhneDownloadFunktionLeben) {
            this.rollenBeforDelete.push("F08-MP-BDLOD");
        }
        if (result.indexOf("F21-MP-SB-KD") > -1 && !this.isMitDownloadFunktionKranken) {
            this.rollenBeforDelete.push("F21-MP-SB-KD");
        }
        if (result.indexOf("F22-MP-SB-OD") > -1 && !this.isOhneDownloadFunktionKranken) {
            this.rollenBeforDelete.push("F22-MP-SB-OD");
        }
        if (result.indexOf("F25-MP-SLTLK") > -1 && !this.isZusaetzlicheAnzeige) {
            this.rollenBeforDelete.push("F25-MP-SLTLK");
        }
    };
    AppMeinkonto.prototype.checkNewRoles = function (addedRollen) {
        for (var i = 0; i < this.rollen.length; i++) {
            for (var j = 0; j < addedRollen.length; j++) {
                if (this.rollen[i].indexOf(addedRollen[j]) > -1) {
                    this.rollenNew.splice(j, 1);
                }
            }
        }
    };
    return AppMeinkonto;
}());
export { AppMeinkonto };
var DialogOverview = /** @class */ (function () {
    function DialogOverview(dialogRef, data, meinkonto) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.meinkonto = meinkonto;
    }
    DialogOverview.prototype.onNoClick = function () {
        this.dialogRef.close();
    };
    return DialogOverview;
}());
export { DialogOverview };
